import React, {
  forwardRef,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import Select from "common-ui-components/components/select";
import styles from "../SupportForm.module.css";
import { MAIL_TYPE, sendSupportMail } from "../../api";

const MODULE_OPTIONS = [
  "Patch & Vulnerability Management",
  "Hardware & Software Inventory",
  "Software Deployment",
  "Policy & Configuration Management",
  "Device Control",
  "Application Control",
  "Remote Troubleshooting",
  "Endpoint Monitoring",
];

const Feature = forwardRef((_, ref) => {
  const formRef = useRef(null);

  const [title, setTitle] = useState("");
  const [module, setModule] = useState(MODULE_OPTIONS[0]);
  const [description, setDescription] = useState("");
  const [useCase, setUseCase] = useState("");

  const moduleActiveIndex = MODULE_OPTIONS.findIndex((opt) => opt === module);

  useImperativeHandle(ref, () => ({
    submit: async () => {
      if (formRef.current && !formRef.current.reportValidity()) {
        return { success: false };
      }
      try {
        await sendSupportMail({
          mailType: MAIL_TYPE.FEATURE_REQUEST,
          payload: {
            featureRequestDTO: {
              featureTitle: title,
              featureModule: module,
              featureDescription: description,
              useCaseDescription: useCase,
            },
          },
        });
        return { success: true };
      } catch (err) {
        return { success: false, error: err.message };
      }
    },
  }));

  return (
    <form
      ref={formRef}
      className={styles.form}
      onSubmit={(e) => e.preventDefault()}
    >
      <div className={styles.field}>
        <label className={styles.label} htmlFor="featureTitle">
          Feature title<span className={styles.required}>*</span>
        </label>
        <input
          id="featureTitle"
          className={styles.input}
          placeholder="e.g. Slack alert when a device fails compliance"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          required
        />
      </div>

      <div className={styles.field}>
        <label className={styles.label} htmlFor="relatedModule">
          Related module
        </label>
        <Select
          options={MODULE_OPTIONS}
          active={Math.max(moduleActiveIndex, 0)}
          onOptionSelect={(option) => setModule(option)}
          triggerProps={{ id: "relatedModule", className: styles.select }}
        />
      </div>

      <div className={styles.field}>
        <label className={styles.label} htmlFor="featureDescription">
          Feature description<span className={styles.required}>*</span>
        </label>
        <textarea
          id="featureDescription"
          className={styles.textarea}
          placeholder="Describe your feature request in detail."
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          required
        />
      </div>

      <div className={styles.field}>
        <label className={styles.label} htmlFor="featureUseCase">
          What's your real time use case, and how do you achieve it today?
          <span className={styles.required}>*</span>
        </label>
        <textarea
          id="featureUseCase"
          className={[styles.textarea, styles.scenario].join(" ")}
          placeholder="Describe your scenario and how you handle it today."
          value={useCase}
          onChange={(e) => setUseCase(e.target.value)}
          required
        />
      </div>
    </form>
  );
});

Feature.displayName = "Feature";
export default Feature;
